import * as Yup from "yup";

const expenseSchema = {};

expenseSchema.validateAdd = (values) => {
    let schema = Yup.object({
        dt_of_exp: Yup.string().required("Expense Date is Required."),
        exp_type: Yup.string().required("Expense Type is Required."),
        exp_cat_id: Yup.string().when("exp_type", {
          is: (val) => [1, 2, "1", "2"].includes(val),
          then: Yup.string().required("Expense Category is Required."),
          otherwise: Yup.string().nullable(),
        }),
        cashier_id: Yup.string().when("exp_type", {
            is: (val) => val == 3, // when exp_type is 3
            then: Yup.string().required("Cashier Name is Required."),
            otherwise: Yup.string().nullable(),
        }),
        exp_dtl: Yup.array()
            .of(Yup.object({
                item_name: Yup.string().required("Expense Description is Required."),
                qty: Yup.string().required("Quantity is Required."),
                // rate: Yup.string().required("Rate is Required."),
                rate: Yup.number().typeError('Amount must be number')
                    .transform((_, v) => v == "" ? null : Number(v))
                    .min(0, "Amount must be greater than or equal to 0")
                    .nullable().required('Amount field is required')
                    .max(999999999999999.9999, 'Amount cannot exceed 15 Digits'),
            }))
            .min(1, "Invalid Expense Details."),
    });

    return schema.validate(values, {abortEarly: false}).catch((err) => err);
};

expenseSchema.validateEdit = (values) => {
    let schema = Yup.object({
        dt_of_exp: Yup.string().required("Expense Date is Required."),
        exp_type: Yup.string().required("Expense Type is Required."),
        exp_cat_id: Yup.string().when("exp_type", {
          is: (val) => [1, 2, "1", "2"].includes(val),
          then: Yup.string().required("Expense Category is Required."),
          otherwise: Yup.string().nullable(),
        }),
        exp_dtl: Yup.array()
            .of(Yup.object({
                item_name: Yup.string().required("Item Name is Required."),
                qty: Yup.string().required("Quantity is Required."),
                // rate: Yup.string().required("Rate is Required."),
                rate: Yup.number().typeError('Amount must be number')
                    .transform((_, v) => v == "" ? null : Number(v))
                    .min(0, "Amount must be greater than or equal to 0")
                    .nullable().required('Amount field is required')
                    .max(999999999999999.9999, 'Amount cannot exceed 15 Digits'),
            }))
            .min(1, "Invalid Expense Details."),
    });

    return schema.validate(values, {abortEarly: false}).catch((err) => err);
};

export default expenseSchema;
